import { Injectable, defineInjectable, EventEmitter, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {number} */
var NgxKeyCode = {
    // letters and numbers
    A: 65,
    B: 66,
    C: 67,
    D: 68,
    E: 69,
    F: 70,
    G: 71,
    H: 72,
    I: 73,
    J: 74,
    K: 75,
    L: 76,
    M: 77,
    N: 78,
    O: 79,
    P: 80,
    Q: 81,
    R: 82,
    S: 83,
    T: 84,
    U: 85,
    V: 86,
    W: 87,
    X: 88,
    Y: 89,
    Z: 90,
    Digit0: 48,
    Digit1: 49,
    Digit2: 50,
    Digit3: 51,
    Digit4: 52,
    Digit5: 53,
    Digit6: 54,
    Digit7: 55,
    Digit8: 56,
    Digit9: 57,
    Space: 32,
    // punctuation
    Backslash: 220,
    BracketLeft: 219,
    BracketRight: 221,
    Comma: 188,
    Grave: 192,
    Period: 190,
    Quote: 222,
    Semicolon: 186,
    Slash: 191,
    // modifiers
    Ctrl: 17,
    Shift: 16,
    Alt: 18,
    MetaLeft: 91,
    WinLeft: 91,
    MetaRight: 92,
    WinRight: 92,
    // F keys
    F1: 112,
    F2: 113,
    F3: 114,
    F4: 115,
    F5: 116,
    F6: 117,
    F7: 118,
    F8: 119,
    F9: 120,
    F10: 121,
    F11: 122,
    F12: 123,
    // random commands
    Delete: 46,
    End: 35,
    Escape: 27,
    Home: 36,
    Insert: 45,
    PageUp: 33,
    PageDown: 34,
    Pause: 19,
    PrintScreen: 44,
    Return: 13,
    // arrow keys
    LeftArrow: 37,
    UpArrow: 38,
    RightArrow: 39,
    DownArrow: 40,
    // locks
    CapsLock: 9,
    NumLock: 144,
    ScrollLock: 145,
    // numpad
    NumPad0: 96,
    NumPad1: 97,
    NumPad2: 98,
    NumPad3: 99,
    NumPad4: 100,
    NumPad5: 101,
    NumPad6: 102,
    NumPad7: 103,
    NumPad8: 104,
    NumPad9: 105,
    NumPadAdd: 117,
    NumPadDecimal: 110,
    NumPadDivide: 111,
    NumPadEnter: 113,
    NumPadMultiply: 106,
    NumPadSubtract: 109,
};
NgxKeyCode[NgxKeyCode.A] = "A";
NgxKeyCode[NgxKeyCode.B] = "B";
NgxKeyCode[NgxKeyCode.C] = "C";
NgxKeyCode[NgxKeyCode.D] = "D";
NgxKeyCode[NgxKeyCode.E] = "E";
NgxKeyCode[NgxKeyCode.F] = "F";
NgxKeyCode[NgxKeyCode.G] = "G";
NgxKeyCode[NgxKeyCode.H] = "H";
NgxKeyCode[NgxKeyCode.I] = "I";
NgxKeyCode[NgxKeyCode.J] = "J";
NgxKeyCode[NgxKeyCode.K] = "K";
NgxKeyCode[NgxKeyCode.L] = "L";
NgxKeyCode[NgxKeyCode.M] = "M";
NgxKeyCode[NgxKeyCode.N] = "N";
NgxKeyCode[NgxKeyCode.O] = "O";
NgxKeyCode[NgxKeyCode.P] = "P";
NgxKeyCode[NgxKeyCode.Q] = "Q";
NgxKeyCode[NgxKeyCode.R] = "R";
NgxKeyCode[NgxKeyCode.S] = "S";
NgxKeyCode[NgxKeyCode.T] = "T";
NgxKeyCode[NgxKeyCode.U] = "U";
NgxKeyCode[NgxKeyCode.V] = "V";
NgxKeyCode[NgxKeyCode.W] = "W";
NgxKeyCode[NgxKeyCode.X] = "X";
NgxKeyCode[NgxKeyCode.Y] = "Y";
NgxKeyCode[NgxKeyCode.Z] = "Z";
NgxKeyCode[NgxKeyCode.Digit0] = "Digit0";
NgxKeyCode[NgxKeyCode.Digit1] = "Digit1";
NgxKeyCode[NgxKeyCode.Digit2] = "Digit2";
NgxKeyCode[NgxKeyCode.Digit3] = "Digit3";
NgxKeyCode[NgxKeyCode.Digit4] = "Digit4";
NgxKeyCode[NgxKeyCode.Digit5] = "Digit5";
NgxKeyCode[NgxKeyCode.Digit6] = "Digit6";
NgxKeyCode[NgxKeyCode.Digit7] = "Digit7";
NgxKeyCode[NgxKeyCode.Digit8] = "Digit8";
NgxKeyCode[NgxKeyCode.Digit9] = "Digit9";
NgxKeyCode[NgxKeyCode.Space] = "Space";
NgxKeyCode[NgxKeyCode.Backslash] = "Backslash";
NgxKeyCode[NgxKeyCode.BracketLeft] = "BracketLeft";
NgxKeyCode[NgxKeyCode.BracketRight] = "BracketRight";
NgxKeyCode[NgxKeyCode.Comma] = "Comma";
NgxKeyCode[NgxKeyCode.Grave] = "Grave";
NgxKeyCode[NgxKeyCode.Period] = "Period";
NgxKeyCode[NgxKeyCode.Quote] = "Quote";
NgxKeyCode[NgxKeyCode.Semicolon] = "Semicolon";
NgxKeyCode[NgxKeyCode.Slash] = "Slash";
NgxKeyCode[NgxKeyCode.Ctrl] = "Ctrl";
NgxKeyCode[NgxKeyCode.Shift] = "Shift";
NgxKeyCode[NgxKeyCode.Alt] = "Alt";
NgxKeyCode[NgxKeyCode.MetaLeft] = "MetaLeft";
NgxKeyCode[NgxKeyCode.WinLeft] = "WinLeft";
NgxKeyCode[NgxKeyCode.MetaRight] = "MetaRight";
NgxKeyCode[NgxKeyCode.WinRight] = "WinRight";
NgxKeyCode[NgxKeyCode.F1] = "F1";
NgxKeyCode[NgxKeyCode.F2] = "F2";
NgxKeyCode[NgxKeyCode.F3] = "F3";
NgxKeyCode[NgxKeyCode.F4] = "F4";
NgxKeyCode[NgxKeyCode.F5] = "F5";
NgxKeyCode[NgxKeyCode.F6] = "F6";
NgxKeyCode[NgxKeyCode.F7] = "F7";
NgxKeyCode[NgxKeyCode.F8] = "F8";
NgxKeyCode[NgxKeyCode.F9] = "F9";
NgxKeyCode[NgxKeyCode.F10] = "F10";
NgxKeyCode[NgxKeyCode.F11] = "F11";
NgxKeyCode[NgxKeyCode.F12] = "F12";
NgxKeyCode[NgxKeyCode.Delete] = "Delete";
NgxKeyCode[NgxKeyCode.End] = "End";
NgxKeyCode[NgxKeyCode.Escape] = "Escape";
NgxKeyCode[NgxKeyCode.Home] = "Home";
NgxKeyCode[NgxKeyCode.Insert] = "Insert";
NgxKeyCode[NgxKeyCode.PageUp] = "PageUp";
NgxKeyCode[NgxKeyCode.PageDown] = "PageDown";
NgxKeyCode[NgxKeyCode.Pause] = "Pause";
NgxKeyCode[NgxKeyCode.PrintScreen] = "PrintScreen";
NgxKeyCode[NgxKeyCode.Return] = "Return";
NgxKeyCode[NgxKeyCode.LeftArrow] = "LeftArrow";
NgxKeyCode[NgxKeyCode.UpArrow] = "UpArrow";
NgxKeyCode[NgxKeyCode.RightArrow] = "RightArrow";
NgxKeyCode[NgxKeyCode.DownArrow] = "DownArrow";
NgxKeyCode[NgxKeyCode.CapsLock] = "CapsLock";
NgxKeyCode[NgxKeyCode.NumLock] = "NumLock";
NgxKeyCode[NgxKeyCode.ScrollLock] = "ScrollLock";
NgxKeyCode[NgxKeyCode.NumPad0] = "NumPad0";
NgxKeyCode[NgxKeyCode.NumPad1] = "NumPad1";
NgxKeyCode[NgxKeyCode.NumPad2] = "NumPad2";
NgxKeyCode[NgxKeyCode.NumPad3] = "NumPad3";
NgxKeyCode[NgxKeyCode.NumPad4] = "NumPad4";
NgxKeyCode[NgxKeyCode.NumPad5] = "NumPad5";
NgxKeyCode[NgxKeyCode.NumPad6] = "NumPad6";
NgxKeyCode[NgxKeyCode.NumPad7] = "NumPad7";
NgxKeyCode[NgxKeyCode.NumPad8] = "NumPad8";
NgxKeyCode[NgxKeyCode.NumPad9] = "NumPad9";
NgxKeyCode[NgxKeyCode.NumPadAdd] = "NumPadAdd";
NgxKeyCode[NgxKeyCode.NumPadDecimal] = "NumPadDecimal";
NgxKeyCode[NgxKeyCode.NumPadDivide] = "NumPadDivide";
NgxKeyCode[NgxKeyCode.NumPadEnter] = "NumPadEnter";
NgxKeyCode[NgxKeyCode.NumPadMultiply] = "NumPadMultiply";
NgxKeyCode[NgxKeyCode.NumPadSubtract] = "NumPadSubtract";
/** @enum {number} */
var NgxKeyModifier = {
    Alt: 0,
    CtrlCmd: 1,
    Shift: 2,
};
NgxKeyModifier[NgxKeyModifier.Alt] = "Alt";
NgxKeyModifier[NgxKeyModifier.CtrlCmd] = "CtrlCmd";
NgxKeyModifier[NgxKeyModifier.Shift] = "Shift";
var NgxKeyboardEvent = /** @class */ (function () {
    function NgxKeyboardEvent() {
    }
    return NgxKeyboardEvent;
}());
var NgxKeyboardEventsService = /** @class */ (function () {
    function NgxKeyboardEventsService() {
        var _this = this;
        this.onKeyPressed = new EventEmitter();
        // can't use HostListener in a service :/
        window.addEventListener('keyup', function (event) {
            _this.onKeyPressed.emit(_this.resolveKeyboardEvent(event));
        });
    }
    /**
     * @param {?} keyEvent
     * @return {?}
     */
    NgxKeyboardEventsService.prototype.resolveKeyboardEvent = /**
     * @param {?} keyEvent
     * @return {?}
     */
    function (keyEvent) {
        var /** @type {?} */ modifiers = [];
        if (keyEvent.altKey) {
            modifiers.push(NgxKeyModifier.Alt);
        }
        if (keyEvent.ctrlKey) {
            modifiers.push(NgxKeyModifier.CtrlCmd);
        }
        if (keyEvent.shiftKey) {
            modifiers.push(NgxKeyModifier.Shift);
        }
        return {
            code: /** @type {?} */ (keyEvent.keyCode),
            modifiers: modifiers,
            name: keyEvent.code
        };
    };
    NgxKeyboardEventsService.decorators = [
        { type: Injectable, args: [{ providedIn: 'root' },] }
    ];
    /** @nocollapse */
    NgxKeyboardEventsService.ctorParameters = function () { return []; };
    /** @nocollapse */ NgxKeyboardEventsService.ngInjectableDef = defineInjectable({ factory: function NgxKeyboardEventsService_Factory() { return new NgxKeyboardEventsService(); }, token: NgxKeyboardEventsService, providedIn: "root" });
    return NgxKeyboardEventsService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var NgxKeyboardEventsModule = /** @class */ (function () {
    function NgxKeyboardEventsModule() {
    }
    NgxKeyboardEventsModule.decorators = [
        { type: NgModule, args: [{ providers: [NgxKeyboardEventsService] },] }
    ];
    return NgxKeyboardEventsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { NgxKeyCode, NgxKeyModifier, NgxKeyboardEvent, NgxKeyboardEventsModule, NgxKeyboardEventsService };
//# sourceMappingURL=ngx-keyboard-events.js.map
